import {useQuery} from 'react-query';

import {useAuth} from '../../../context/authContext';
import {getProfile} from '../../profile';

const useGetSupplierProfile = ({
  handleAfterSuccess,
  enabled = true,
}: {
  handleAfterSuccess?: (data: IProfile) => void;
  enabled?: boolean;
}) => {
  const {supplierProfile, update} = useAuth();

  const {data, isLoading, isError} = useQuery({
    queryKey: ['user-profile', supplierProfile?.guid],
    queryFn: () => getProfile(),
    onSuccess: data => {
      update(data as IProfile);
      handleAfterSuccess && handleAfterSuccess(data);
    },
    enabled: Boolean(enabled),
    cacheTime: 0,
  });

  return {data, isLoading, isError};
};

export default useGetSupplierProfile;
